/* src/app/common/components/smartdine-table/smartdine-table.component.scss */
:host {
  display: block;
  width: 100%;
}
.table-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.datatable-header {
  background-color: #007bff;
  color: #fff;
  padding: 10px;
  font-size: 18px;
  text-align: center;
  width: 100%;
}
.datatable-header .datatable-header .datatable-row-center {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}
.datatable-container {
  width: 100%;
  overflow: auto;
}
.datatable-pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background-color: #f1f1f1;
  width: 100%;
}
.datatable-pagination .page-size {
  width: 100%;
  --padding-start: 0;
  --padding-end: 0;
}
.datatable-pagination .pagination-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.datatable-pagination .pagination-buttons ion-button {
  margin: 0 10px;
}
.datatable-pagination .pagination-buttons .page-info {
  font-weight: bold;
}
/*# sourceMappingURL=smartdine-table.component.css.map */
